// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__RbVbb","header":"Layout_header__1sVq3","aside":"Layout_aside__2tXmO","main":"Layout_main__9ZS2x","footer":"Layout_footer__1tm8y"};